import { render, staticRenderFns } from "./ColorCardManageExtends.vue?vue&type=template&id=6324ffe8&"
import script from "./ColorCardManageExtends.vue?vue&type=script&lang=js&"
export * from "./ColorCardManageExtends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ColorCardManageExtends.vue"
export default component.exports